import clsx from 'clsx';
import BasicButton from 'core/BasicButton';
import BasicImage from 'core/BasicImage';
import BasicLink from 'core/BasicLink';
import React from 'react';

import cn from '../style.module.sass';

type SlidePropsType = {
    title: string;
    image: string;
    href: string;
    imageLight: string;
};

const Service = ({ title, image, href, imageLight }: SlidePropsType) => {
    const classItem = cn['services__item'];
    const classItemImage = cn['services__item-image'];

    return (
        <BasicLink href={href}>
            <div className={classItem}>
                <div className={classItemImage}>
                    <BasicImage
                        fill
                        src={image}
                        alt={title}
                        className={clsx(cn['basic'], classItemImage)}
                    />
                    <BasicImage
                        fill
                        src={imageLight}
                        alt={title}
                        className={clsx(cn['hover'], classItemImage)}
                    />
                </div>
                <div className={cn['services__item-title']}>{title}</div>
                <div>
                    <BasicButton className={cn['button']}>ПОДРОБНЕЕ</BasicButton>
                </div>
            </div>
        </BasicLink>
    );
};

export default Service;
